import { CenterModal } from '@dehaat/dds';
import useTranslation from 'next-translate/useTranslation';
import React from 'react';
import CartIcon from './icons/CartIcon';
import HeartIcon from './icons/HeartIcon';
interface Props {
  isOpen: boolean;
  onClose: () => void;
  onMoveToWishlist: () => void;
  onRemoveFromCart: () => void;
}
const MoveToWishlist = ({
  isOpen,
  onClose,
  onMoveToWishlist,
  onRemoveFromCart
}: Props) => {
  const {
    t
  } = useTranslation('cart');
  return <CenterModal isVisible={isOpen} onClose={onClose} style={{
    padding: 8
  }} data-sentry-element="CenterModal" data-sentry-component="MoveToWishlist" data-sentry-source-file="MoveToWishlist.tsx">
      <div className="bg-white rounded-lg">
        <div className="flex justify-center items-center">
          <CartIcon height={48} width={48} path1Color={'#33393D'} path2Color={'#DAF5E6'} path3Color={'#0E7A41'} path4Color={'#33393D'} data-sentry-element="CartIcon" data-sentry-source-file="MoveToWishlist.tsx" />
        </div>

        <div className="gap-1 my-4 text-center">
          <h5 className="font-semibold text-[#33393D] text-base">
            {`${t('remove_from_cart')}`}
          </h5>
          <p className="font-normal text-[#5A6066] text-sm">
            {`${t('move_item_to_wishlist')}`}
          </p>
        </div>

        <div className="flex justify-center gap-3">
          <button onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          onRemoveFromCart();
        }} className="bg-[#CC293F] px-4 py-2 rounded-lg text-white">
            <p className="font-semibold text-white text-sm">{`${t('remove')}`}</p>
          </button>
          <button onClick={e => {
          e.stopPropagation();
          e.preventDefault();
          onMoveToWishlist();
        }} className="flex justify-center items-center gap-2 bg-white px-4 py-2 border border-[#E6EBF0] rounded-lg">
            <HeartIcon width={16} height={14} data-sentry-element="HeartIcon" data-sentry-source-file="MoveToWishlist.tsx" />
            <p className="font-medium text-[#33393D] text-sm">
              {`${t('move_to_wishlist')}`}
            </p>
          </button>
        </div>
      </div>
    </CenterModal>;
};
export default MoveToWishlist;